import PropTypes from 'prop-types';
import React from 'react';

import { Container, ImageCar, Title, Scroll } from './styles';

function CardList({ data, changeValue }) {
  return (
    <Scroll>
      {data.map(item => (
        <Container key={item.id} onClick={() => changeValue(item)}>
          <ImageCar
            src={`${process.env.REACT_APP_FILES_URL}/${item.image}`}
            alt="foto do tipo"
          />
          <Title>{item.name}</Title>
        </Container>
      ))}
    </Scroll>
  );
}
CardList.propTypes = {
  data: PropTypes.arrayOf.isRequired,
  changeValue: PropTypes.func.isRequired,
};
export default CardList;
